import DriDimensionListApproval from './DriDimensionListApproval';

export default DriDimensionListApproval;
